import { Component, ViewChild } from '@angular/core';
import { Content, NavController, NavParams } from 'ionic-angular';

@Component({
    selector: 'page-chat',
    templateUrl: 'chat.html',
})
export class ChatPage {
    @ViewChild(Content) content: Content; // access ion-content

    booking: any;
    messages: any[] = [];

    constructor(public navCtrl: NavController, public navParams: NavParams) {
        this.booking = this.navParams.get('booking'); // receive booking data

        // Sample messages
        this.messages = [
            {
                type: 'other',
                text: `<strong>Hey </strong><br />
      Your booking with is confirmed as shown below.<br /><br />
      28th April 2025 2:05am<br />
      30 mins. $200.00<br />
      TOTAL PAID: $50.00<br />
      TOTAL DUE: $150.00`,
                time: '10:33 AM'
            },
            {
                type: 'other',
                text: `Hey Your appointment is in 15 minutes please confirm you are on your way`,
                time: '10:33 AM'
            },
            {
                type: 'self',
                text: `On my way see you soon`,
                time: '10:33 AM'
            }, {
                type: 'other',
                text: `<strong>Hey </strong><br />
      Your booking with is confirmed as shown below.<br /><br />
      28th April 2025 2:05am<br />
      30 mins. $200.00<br />
      TOTAL PAID: $50.00<br />
      TOTAL DUE: $150.00`,
                time: '10:33 AM'
            },
            {
                type: 'other',
                text: `Hey Your appointment is in 15 minutes please confirm you are on your way`,
                time: '10:33 AM'
            },
            {
                type: 'self',
                text: `On my way see you soon`,
                time: '10:33 AM'
            }
        ];
    }
    ionViewDidEnter() {
        // Scroll to bottom when entering the chat
        setTimeout(() => {
            this.scrollToBottom();
        }, 300);
    }

    scrollToBottom() {
        this.content.scrollToBottom(300); // smooth scroll
    }

    sendQuickReply(text: string) {
        this.messages.push({ type: 'self', text });
        setTimeout(() => {
            this.scrollToBottom();
        }, 100);
    }
}



// WEBPACK FOOTER //
// ./src/pages/chat/chat.ts